'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const BaseDirective=require('../../../dist-es6/client/angularCommon/baseDirective');let

VirtualRepeatShadowDirective=function(_BaseDirective){_inherits(VirtualRepeatShadowDirective,_BaseDirective);function VirtualRepeatShadowDirective(){_classCallCheck(this,VirtualRepeatShadowDirective);return _possibleConstructorReturn(this,_BaseDirective.apply(this,arguments))}VirtualRepeatShadowDirective.prototype.




link=function link($scope,$element,$attrs){
const scrollerElement=angular.element($element).find('.md-virtual-repeat-scroller');

if(!$attrs.scrollerShadowElement){
throw new Error(`[VirtualRepeatShadowDirective] Attribute "scroller-shadow-element" not defined on directive element.`);
}

const shadowElement=angular.element($attrs.scrollerShadowElement);

if(!_.exists(shadowElement)||shadowElement.length===0){
throw new Error(`[VirtualRepeatShadowDirective] Element described by "scroller-shadow-element" cannot be found.`);
}

let isAtTop=!0;

const onScrollHandler=function(scrollTop){
let wasAtTop=isAtTop;
isAtTop=scrollTop===0;

if(wasAtTop==isAtTop){
return;
}

if(isAtTop){
shadowElement.removeClass('scroller-shadow');
}else{
shadowElement.addClass('scroller-shadow');
}
};

$scope.$evalAsync(function(){
scrollerElement.scroll(function(){
fastdom.measure(function(){
let scrollTop=scrollerElement.scrollTop();
$scope.$apply(function(){
onScrollHandler(scrollTop);
});
});
});
});
};_createClass(VirtualRepeatShadowDirective,[{key:'restrict',get:function(){return'A'}}]);return VirtualRepeatShadowDirective}(BaseDirective);


module.exports=VirtualRepeatShadowDirective;
//# sourceMappingURL=virtualRepeatShadowDirective.js.map
